import { useState } from "react";
import { Button, Input } from "antd";
import { useTranslation } from "react-i18next";
import { BrightMarketApi } from "../../api/BrightMarketApi";

import styles from "./ChatIa.module.scss";

const ChatIa = () => {
  const { t } = useTranslation();

  const [messages, setMessages] = useState([
    { text: "¡Hola! ¿En qué puedo ayudarte?", isUser: false },
  ]);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendMessage = async () => {
    if (inputText.trim() === "") return;

    setLoading(true);
    const newUserMessage = { text: inputText, isUser: true };
    const updatedMessages = [...messages, newUserMessage];
    setMessages(updatedMessages);
    setInputText("");

    try {
      const data = await BrightMarketApi.sendPrompt(inputText);
      const botResponse = { text: data.result, isUser: false };
      setLoading(false);
      setMessages([...updatedMessages, botResponse]);
    } catch (error) {
      console.error("Error fetching data:", error);
      const errorMessage = { text: t("Common-ErrorMessage"), isUser: false };
      setMessages([...updatedMessages, errorMessage]);
      setLoading(false);
    }
  };

  return (
    <div className={styles.chatContainer}>
      <div className={styles.chatMessages}>
        {messages.map((message, index) => (
          <div
            key={index}
            className={`${styles.message} ${
              message.isUser ? styles.user : styles.bot
            }`}
          >
            {message.text}
          </div>
        ))}
      </div>
      <div className={styles.chatInput}>
        <Input
          type="text"
          placeholder={t("ChatIa-inputPlaceholder")}
          value={inputText}
          disabled={loading}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") handleSendMessage();
          }}
        />
        <Button onClick={handleSendMessage} loading={loading}>
          {t("ChatIa-send")}
        </Button>
      </div>
    </div>
  );
};

export default ChatIa;
